import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { MarkInboundEmailAsReadMutation } from '@/gql/graphql';

const MARK_INBOUND_EMAIL_AS_READ_MUTATION = graphql(`
  mutation MarkInboundEmailAsRead($inboundEmailId: ID!) {
    markInboundEmailAsRead(inboundEmailId: $inboundEmailId) {
      id
      status
    }
  }
`);

const useMarkInboundEmailAsRead = (
  options?: UseMutationOptions<
    MarkInboundEmailAsReadMutation,
    unknown,
    { inboundEmailId: string }
  >
) => {
  return useMutation({
    mutationFn: ({ inboundEmailId }) => {
      return gqlClient.request(MARK_INBOUND_EMAIL_AS_READ_MUTATION, {
        inboundEmailId,
      });
    },
    ...options,
  });
};

export default useMarkInboundEmailAsRead;
